export default function XSLT_ValueOf() {
  return (
    <div>
      <h1>XSLT_ValueOf</h1>
      <p>This is the XSLT_ValueOf component.</p>
    </div>
  );
}